import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  togglerWrapper: {
    marginTop: '18px',
    display: 'flex'
  },
  toggler: {
    marginRight: '10px'
  },
  pageFooter: {
    marginTop: '40px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  fieldXs: {
    width: '120px',
    marginLeft: '10px'
  },
  fieldSm: {
    width: '160px',
    [breakpointsFunc.breakpoints.down('md')]: {
      width: '120px'
    }
  },
  fieldMd: {
    maxWidth: '240px',
    minWidth: '210px',
    width: '100%',
    marginLeft: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      maxWidth: '150px',
      minWidth: '150px'
    }
  },
  unitInfo: {
    display: 'flex',
    '& + &': {
      marginTop: '24px'
    }
  },
  unitsList: {
    backgroundColor: palette.shades[200],
    padding: '32px 40px',
    margin: '0 -40px -48px -40px'
  },
  unitMultiSetup: {
    backgroundColor: palette.shades[100],
    padding: '32px 40px',
    margin: '0 -40px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      margin: '0 -24px'
    }
  },
  infoBlock: {
    margin: '48px -40px 0 -40px'
  },
  buildingInfo: {
    display: 'flex',
    marginTop: '24px',
    padding: '18px 24px',
    borderRadius: '2px',
    border: "2px solid ".concat(palette.shades[300]),
    alignItems: 'center',
    justifyContent: 'space-between',
    '& + &': {
      marginTop: '10px'
    }
  },
  buildingInfoText: {
    flexGrow: '1',
    margin: '0 20px'
  },
  portfolioSelector: {
    width: '540px',
    marginTop: '24px'
  },
  podAction: {
    display: 'flex',
    alignItems: 'center',
    '& .modal-trigger': {
      display: 'inline-block',
      marginRight: '10px'
    }
  },
  collaborator: {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(palette.shades[400]),
    display: 'flex',
    fontFamily: palette.fontFamilies.poppins,
    padding: '12px 20px'
  },
  avatar: {
    backgroundColor: palette.info.main,
    border: '1px solid',
    borderRadius: '50%',
    color: palette.common.white,
    height: '32px',
    fontSize: '13px',
    fontFamily: palette.fontFamilies.poppins,
    fontWeight: '600',
    flexShrink: '0',
    lineHeight: '32px',
    marginRight: '10px',
    textAlign: 'center',
    width: '32px'
  }
}));
export default useStyles;